<link href="https://fonts.googleapis.com/css?family=Raleway:100,600" rel="stylesheet" type="text/css">
<div class="tool-bar" id="tool-bar">
  <dx-toolbar id="toolbar">
    <dxi-item 
        widget="dxButton"
        [options]="buttonOptions"
        location="before">
    </dxi-item>
  </dx-toolbar>
  <a routerLink="/"><img src="../assets/OTD_Promoflo_Brandmark_Reversed.svg" height="90%" class="logo"></a>
  @if(weekRange && endDate && displayWeekRange){
    <div class="week-range-display">
      Displaying promotions between: <b>{{ weekRange.startWeek }} </b>to <b>{{ endDate }} </b>
    </div>
  }
  
  <!-- Price Watcher — researches live retail web prices for a product in a popup.
       Only rendered for users holding the pf_watcher role. -->
  @if (priceWatcherAllowed) {
    <dx-button
      class="price-watcher-button"
      text="Price Watcher"
      icon="money"
      hint="Check retail prices across the web"
      stylingMode="contained"
      type="default"
      (onClick)="priceWatcherVisible = true"
    ></dx-button>
  }
  <div class="logged-in-logo">
    <img [src]="userImage()"/>
  </div>
  @if(infoCardsCountWarnings) {
    <div class="info-header" (click)="navigateToNotifications()">
      <div class="notification-parent">
        <div class="notification-div">
          <i class="notification dx-icon-bell"></i>
          <span class="notification-value">
            {{infoCardsCountWarnings + infoCardsCountErrors}}
          </span>
        </div>
      </div>
    </div>
  }
  <div class="fields-container">
    <div class="dx-field">
      <div class="dx-field-value">
        <dx-drop-down-button
          class="profile-button"
          style="color: white !important;"
          [splitButton]="false"
          [useSelectMode]="false"
          [text]="userName"
          icon="user"
          [items]="profileSettings"
          displayExpr="name"
          keyExpr="id"
          stylingMode="text"
          [dropDownOptions]="{  
            width: 170  
        }"  
          (onItemClick)="itemClick($event)"
        >
      </dx-drop-down-button>
      </div>
    </div>
  </div>
  <dx-popup class="profilePopup" id="profilePopup" [wrapperAttr]="{ id: 'profilePopupId' ,class: 'profilePopup' }"
    [(visible)]="profileComponent.editProfile"
    [hideOnOutsideClick]="true"
    [showTitle]="true"
    title="Edit Profile"
    height="auto"
    width="auto"
    [showCloseButton]="true"
    (onHiding)="profileComponent.onHiding($event)" 
    (onShown)="profileComponent.shown($event)" 
    
    >
    <app-profile #profileComponent></app-profile>
  </dx-popup>

  <!-- Configuration editor — opened from the "Configuration" profile-dropdown item. The editor loads the
       full config list on (onShown) and emits (close) when saved/cancelled. -->
  <dx-popup
    class="configPopup"
    [(visible)]="configVisible"
    [showTitle]="true"
    title="Configuration"
    [width]="620"
    height="auto"
    [showCloseButton]="true"
    [dragEnabled]="false"
    [hideOnOutsideClick]="false"
    (onShown)="configEditor.onShown()"
  >
    <app-config-editor #configEditor (close)="configVisible = false"></app-config-editor>
  </dx-popup>

  <!-- Price Watcher — opened from the header button; wraps its own dx-popup. -->
  @if (priceWatcherAllowed) {
    <app-price-watcher [visible]="priceWatcherVisible" (closed)="priceWatcherVisible = false"></app-price-watcher>
  }
